import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import {
    Drawer,
    Box,
    Typography,
    IconButton,
    Button,
    Divider,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ProductsFilter = ({ 
    typeFilter, 
    setTypeFilter, 
    categoryFilter, 
    setCategoryFilter, 
    activeFilter, 
    setActiveFilter,
    categories = []
}) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClearFilters = () => {
        setTypeFilter('all');
        setCategoryFilter('');
        setActiveFilter('all');
    };

    const handleApplyFilters = () => {
        handleClose();
    };

    // Calcular el número de filtros activos
    const activeFilterCount = useMemo(() => {
        let count = 0;
        if (typeFilter !== 'all') count++;
        if (categoryFilter) count++;
        if (activeFilter !== 'all') count++;
        return count;
    }, [typeFilter, categoryFilter, activeFilter]);

    return (
        <>
            <Link
                to="#"
                className="btn btn-gray filterbtn d-flex align-items-center gap-1 position-relative"
                type="button"
                onClick={handleOpen}
            >
                <div className="filter_text d-flex align-items-center gap-1">
                    <span className="d-block material-symbols-outlined icon-md">tune</span>
                    <span className="d-block">Filter</span>
                </div>
                {activeFilterCount > 0 && (
                    <span
                        className="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-primary"
                        style={{fontSize: '0.6rem', padding: '0.2rem 0.4rem'}}
                    >
                        {activeFilterCount}
                    </span>
                )}
            </Link>

            <Drawer 
                anchor="right" 
                open={open} 
                onClose={handleClose}
            >
                <Box sx={{ width: 400, p: 3 }}>
                    {/* Header */}
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                        <Typography variant="h6" fontWeight="bold">
                            Filters
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Divider sx={{ mb: 3 }} />

                    {/* Filtro por Tipo */}
                    <FormControl fullWidth sx={{ mb: 3 }}>
                        <InputLabel id="type-filter-label">Type</InputLabel>
                        <Select
                            labelId="type-filter-label"
                            value={typeFilter}
                            label="Type"
                            onChange={(e) => setTypeFilter(e.target.value)}
                        >
                            <MenuItem value="all">All Types</MenuItem>
                            <MenuItem value="consumible">Consumibles</MenuItem>
                            <MenuItem value="service">Services</MenuItem>
                        </Select>
                    </FormControl>

                    {/* Filtro por Categoría */}
                    {/* <FormControl fullWidth sx={{ mb: 3 }}>
                        <InputLabel id="category-filter-label">Category</InputLabel>
                        <Select
                            labelId="category-filter-label"
                            value={categoryFilter}
                            label="Category"
                            onChange={(e) => setCategoryFilter(e.target.value)}
                        >
                            <MenuItem value="">All Categories</MenuItem>
                            {categories.map((cat, idx) => (
                                <MenuItem key={idx} value={cat}>
                                    {cat}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl> */}

                    {/* Filtro por Estado */}
                    <FormControl fullWidth sx={{ mb: 3 }}>
                        <InputLabel id="status-filter-label">Status</InputLabel>
                        <Select
                            labelId="status-filter-label"
                            value={activeFilter}
                            label="Status"
                            onChange={(e) => setActiveFilter(e.target.value)}
                        >
                            <MenuItem value="all">All Status</MenuItem>
                            <MenuItem value="active">Active</MenuItem>
                            <MenuItem value="inactive">Inactive</MenuItem>
                        </Select>
                    </FormControl>

                    <Divider sx={{ my: 3 }} />

                    {/* Botones de acción */}
                    <Box display="flex" justifyContent="space-between" gap={2}>
                        <Button 
                            variant="outlined" 
                            fullWidth
                            onClick={handleClearFilters}
                        >
                            Clear All
                        </Button>
                        <Button 
                            variant="contained" 
                            fullWidth
                            onClick={handleApplyFilters}
                        >
                            Apply
                        </Button>
                    </Box>
                </Box>
            </Drawer>
        </>
    );
};

export default ProductsFilter;